function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
import SvgIcon from "@material-ui/core/SvgIcon";

const SafePlace = props => /*#__PURE__*/React.createElement(SvgIcon, _extends({
  viewBox: "0 0 50 40"
}, props, {
  color: "primary"
}), /*#__PURE__*/React.createElement("path", {
  d: "M25,1.1c4.72,0,8.74,3.31,9.53,7.8l0.04,0.27v3.73h1.91v-0.02c2.04,0.01,3.71,1.58,3.81,3.54l0.01,0.2v18.58 c-0.01,1.98-1.61,3.59-3.62,3.7l-0.2,0.01H13.52c-2.04-0.01-3.7-1.56-3.81-3.51l-0.01-0.2v-18.6c0.01-1.98,1.61-3.59,3.62-3.7 l0.2-0.01h1.91V9.17C16.11,4.54,20.19,1.1,25,1.1z M36.7,16.4H13.3v18.9h23.4V16.4z M25,4.64c-3.03,0-5.55,2.01-5.86,4.62 l-0.02,0.21v3.43h11.77V9.48C30.68,6.76,28.11,4.64,25,4.64z",
  fill: "#808285"
}), /*#__PURE__*/React.createElement("circle", {
  cx: "25",
  cy: "26.3",
  r: "3.6"
}));

export default SafePlace;